import { fetchApi } from '@/services/api-client';

export interface ResolvedPerson {
  userId: string;
  name: string;
  photoUrl: string;
  balance: number;
  /** Whole baht this wallet may still be charged below zero. */
  overdraftLimit: number;
}

export interface PosSearchResult {
  personId: string;
  name: string;
  nickname: string | null;
  photoUrl: string;
}

// Thai-QR attribution search result: keyed on userId (parents typically have
// no personId), unlike PosSearchResult's personId-based "forgot card" lookup.
export interface AttributablePerson {
  userId: string;
  name: string;
  nickname: string | null;
  personId: string | null;
  photoUrl: string | null;
}

export interface CheckoutItemInput {
  productId: string;
  quantity: number;
}

export interface CheckoutInput {
  items: CheckoutItemInput[];
  // Defaults to 'wallet' server-side when omitted.
  paymentMethod?: 'wallet' | 'thai_qr';
  // Required for 'wallet' (the account charged); optional attribution for 'thai_qr'.
  userId?: string;
  // Optional walk-up visitor name, only meaningful for 'thai_qr'.
  payerLabel?: string;
}

export interface CheckoutResult {
  orderId: string;
  total: number;
  // null for 'thai_qr' sales — there's no wallet balance to report.
  balance: number | null;
}

const BASE = '/admin/cafeteria/pos';

export const posApi = {
  resolve: (personId: string) => fetchApi<ResolvedPerson>(`${BASE}/resolve?personId=${encodeURIComponent(personId)}`),
  search: (q: string) => fetchApi<PosSearchResult[]>(`${BASE}/search?q=${encodeURIComponent(q)}`),
  attributionSearch: (q: string, roles?: string) => {
    const params = new URLSearchParams({ q });
    if (roles) params.set('roles', roles);
    return fetchApi<AttributablePerson[]>(`${BASE}/attribution-search?${params.toString()}`);
  },
  checkout: (input: CheckoutInput) =>
    fetchApi<CheckoutResult>(`${BASE}/checkout`, { method: 'POST', body: JSON.stringify(input) }),
};
